import { faFileVideo } from '@fortawesome/free-solid-svg-icons';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFilm } from '@fortawesome/free-solid-svg-icons';
import { faTv } from '@fortawesome/free-solid-svg-icons';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons';
import { faGaugeHigh } from '@fortawesome/free-solid-svg-icons';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useRouteStore from '../../hooks/useRouteStore';

const MenuButton = ({ onClick, className, icon, children, to, location, match, exact, exclude }) => {
  className = className || '';
  const isActive = exact
    ? location?.pathname === match
    : location?.pathname.includes(match) && (!exclude || !location?.pathname.includes(exclude));
  if (isActive) {
    className += 'text-red-1';
  } else {
    className += 'text-slate-400';
  }
  return (
    <Link
      to={to}
      className={'flex items-center  hover:bg-red-2 hover:bg-opacity-5 hover:text-red-1 rounded-xl p-2 transition-all ' + (className || '')}
    >
      <FontAwesomeIcon icon={icon} className={className} onClick={onClick} /> &nbsp;{children}
    </Link>
  );
};

const Administration = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const location = useLocation();
  const adminRoute = useRouteStore((state) => state);
  const setRoute = useRouteStore((state) => state.setRoute);

  useEffect(() => {
    if (location.pathname === '/administracion') {
      setRoute([
        {
          name: 'Inicio',
          url: '/administracion',
        },
      ]);
    }
  }, [location]);

  return (
    <div
      className='flex 2xl:max-w-[80%] w-full mx-auto bg-off-white shadow'
      style={{ height: 'calc(100vh - 5rem)', maxHeight: 'calc(100vh - 5rem)' }}
    >
      <div className='min-h-[100%] bg-white font-montserrat font-semibold hidden lg:block'>
        <div className='flex justify-center p-5'>
          <span className='font-pacifico text-2xl mx-auto text-red-1 '>Turkish4love</span>
        </div>
        <div className='flex gap-3 p-5 border-b'>
          <MenuButton icon={faBell}>Notificaciones</MenuButton>
          <div className='rounded-full text-center text-red-1 m-auto bg-red-2 h-6 w-6 bg-opacity-25'>
            <span>{notifications.length}</span>
          </div>
        </div>
        <div className='flex flex-col gap-5 p-5'>
          <MenuButton match='/administracion' exact location={location} icon={faGaugeHigh} to='/administracion'>
            Dashboard
          </MenuButton>
          <MenuButton match='usuarios' location={location} icon={faUsers} to='/administracion/usuarios'>
            Usuarios
          </MenuButton>
          <MenuButton match='series' location={location} icon={faTv} to='/administracion/series'>
            Series
          </MenuButton>
          <MenuButton match='peliculas' location={location} icon={faFilm} to='/administracion/peliculas'>
            {' '}
            Películas
          </MenuButton>
          <MenuButton match='generos' location={location} icon={faTag} to='/administracion/generos'>
            Géneros
          </MenuButton>
          <MenuButton match='videos' location={location} icon={faFileVideo} to='/administracion/videos'>
            &nbsp;&nbsp;Videos
          </MenuButton>
          <MenuButton match='correos' exclude='campanas' location={location} icon={faEnvelope} to='/administracion/correos'>
            {' '}
            Correos
          </MenuButton>
          <MenuButton match='campanas' location={location} icon={faBullhorn} to='/administracion/correos/campanas'>
            {' '}
            Campañas
          </MenuButton>
        </div>
      </div>
      <div id='content-box' className='w-full m-5 mt-2 overflow-y-auto'>
        <div className='flex w-full p-3 font-semibold font-montserrat text-slate-400 text-sm'>
          {adminRoute.route.map((item, index) => {
            return (
              <div key={index}>
                <Link to={item.url} className='hover:text-red-1 transition-all'>
                  {item.name}
                </Link>
                {index < adminRoute.route.length - 1 ? <span className='mx-2'>/</span> : ''}
              </div>
            );
          })}
        </div>
        <div className='bg-white rounded-lg p-5'>{children || null}</div>
      </div>
    </div>
  );
};

export default Administration;
